export const SERVER_AI_ERROR_CODE = {
    DOCUMENT_NOT_EXIST: { code: 5000, i18n: "documentNotFound" },
    AI_VALIDATION_ERROR: { code: 5700, i18n: 'aiValidationError' },
    AI_PROVIDER_NOT_FOUND: { code: 5701, i18n: 'aiProviderNotFound' },
    AI_MODEL_NOT_FOUND: { code: 5702, i18n: 'aiModelNotFound' },
    AI_CHAT_NOT_FOUND: { code: 5703, i18n: 'aiChatNotFound' },
    AI_PROMPT_NOT_FOUND: { code: 5704, i18n: 'aiPromptNotFound' },
    AI_API_KEY_MONTHLY_TOKEN_LIMIT_REACHED: { code: 5705, i18n: 'aiApiKeyMonthlyTokenLimitReached' },
    AI_PROVIDER_ERROR: { code: 5706, i18n: 'aiProviderError' },
    AI_PROVIDER_CONFIG_ERROR: { code: 5707, i18n: 'aiProviderConfigError' },
    AI_INTERNAL_SERVER_ERROR: { code: 5708, i18n: 'aiInternalServerError' },
    AI_NOT_FOUND: { code: 5709, i18n: 'aiResourceNotFound' },
    AI_CONFLICT: { code: 5710, i18n: 'aiConflictError' },
    AI_UNKNOWN_ERROR: { code: 5711, i18n: 'aiUnknownError' },
    AI_CREDITS_INSUFFICIENT: { code: 5712, i18n: 'aiCreditsInsufficient' },
    AI_DISABLED: { code: 5713, i18n: 'aiDisabled' },
    AI_CONTEXT_REQUIRED: { code: 5714, i18n: 'aiContextRequired' },
    AI_EMPTY_CONTENT: { code: 5715, i18n: 'aiEmptyContent' },
    AI_HTML_REQUIRED: { code: 5716, i18n: 'aiHtmlRequired' },
    AI_PROMPT_REQUIRED: { code: 5717, i18n: 'aiPromptRequired' },
    AI_NOT_CONFIGURED: { code: 5718, i18n: 'aiNotConfigured' },
    AI_INSUFFICIENT_CONTEXT: { code: 5719, i18n: 'aiInsufficientContext' },
    AI_NEWS_IGNORED_BY_AI: { code: 5720, i18n: 'aiNewsIgnoredByAi' },
}